import { useContext } from "react";
import { Context2 } from "@/components/Audio";

export function useAudioPreference() {
  return useContext(Context2);
}
